import React from 'react';
import { useNavigate } from 'react-router-dom';
import theme1 from '../Components/Themes/Theme1';

const Intro3 = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/intro2');
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: "url('/images/background.svg')" }}
    >
      {/* Back Button */}
      <div className="absolute top-6 left-6 sm:top-8 sm:left-8 md:top-10 md:left-10 lg:top-12 lg:left-12 z-20">
        <button
          className="flex items-center justify-center hover:bg-gray-100 transition px-3 py-2 rounded-lg"
          onClick={handleBackClick}
        >
          {/* Back Icon */}
          <span
            className="w-4 h-4 sm:w-8 sm:h-8 md:w-6 md:h-6"
            style={{
              backgroundImage: "url('/images/Back-icon.svg')",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              display: "inline-block",
            }}
          ></span>
          {/* Back Text */}
          <span
            className="ml-2 text-sm sm:text-base md:text-lg"
            style={{ fontFamily: "'Archivo', sans-serif" }}
          >
            Back
          </span>
        </button>
      </div>

      {/* Heading */}
      <h1 className="text-center mb-4 text-[#002952] text-lg sm:text-xl md:text-2xl font-semibold"
        style={{
          fontFamily: "'Archivo', sans-serif",
          fontWeight:'600',
        }}>
        Have a look into our demo video for a better idea,<br /> on how to upload a video
      </h1>

      {/* Video Section */}
      <div className="relative w-full max-w-3xl mx-auto mb-4">
      <div className="relative w-full max-h-[80vh] mt-4">
          <div className="relative" style={{ paddingTop: "45.33%" }}> 
            <video
              controls
              autoPlay
              className="absolute inset-0 w-full h-full object-cover rounded-lg shadow-lg"
              controlsList="nodownload noremoteplayback nofullscreen" 
              disablePictureInPicture            >
              <source
                src="https://comskitest.s3.ap-south-1.amazonaws.com/2024-Dec/30sec.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

     {/* Skip Link */}
        <div className="mt-4 flex px-2 justify-between">
            <a href="/" className="text-[#002952] underline text-base">
              Skip
            </a>
            <a href="/" className="text-[#002952] underline text-base">
              Next
            </a>
        </div>

      </div>
    </div>
  );
};

export default Intro3;
